import axios from "axios";
import { message } from "antd";
import { AUTH_TOKEN, SERVER_TYPE } from "configs/AppConfig";
import { errorMessage } from "components/util-components/Message/SuccessErrorMessage";

function LoadingStart(message) {
  CustomLoadingOverlay({ active: true, message: message });
}

function LoadingEnd() {
  CustomLoadingOverlay({ active: false });
}

const CustomLoadingOverlay = ({ active, message }) => {
  return <h1>.....</h1>;
};

const apiRequest = {
  postFile: async (link, data, message) => {
    try {
      LoadingStart(message);

      const response = await axios.post(link, data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN) || null,
        },
      });

      LoadingEnd();
      if (!response.data.success) {
        if ("tokenExpStatus" in response.data) {
          if (response.data.tokenExpStatus) {
            errorMessage(response.data.msg, null);
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem("userDetails");
            window.location.reload();
            return false;
          }
        }
      }

      return response.data;
    } catch (error) {
      console.error("Error:", error);
      LoadingEnd();
      throw error;
    }
  },
  get: async (link, data, message) => {
    try {
      LoadingStart(message);

      const response = await axios.get(link, {
        params: data,

        headers: {
          Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN) || null,
        },
      });

      SERVER_TYPE === "Development" && console.log(message, response.data);

      LoadingEnd();
      if (!response.data.success) {
        if ("tokenExpStatus" in response.data) {
          if (response.data.tokenExpStatus) {
            errorMessage(response.data.msg, null);
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem("userDetails");
            window.location.reload();
            return false;
          }
        }
      }
      return response.data;
    } catch (error) {
      console.error("Error:", error);

      LoadingEnd();

      throw error;
    }
  },
  getExport: async (link, data, message) => {
    try {
      LoadingStart(message);

      const response = await axios.get(link, {
        params: data,
        headers: {
          Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN) || null,
        },
      });

      LoadingEnd();
      if (!response.data.success) {
        if ("tokenExpStatus" in response.data) {
          if (response.data.tokenExpStatus) {
            errorMessage(response.data.msg, null);
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem("userDetails");
            window.location.reload();
            return false;
          }
        }
      }
      return response.data;
    } catch (error) {
      console.error("Error:", error);

      LoadingEnd();

      throw error;
    }
  },
  post: async (link, data, message) => {
    const custom = data?.custom ? data?.custom : null;
    if (custom) {
      delete data.custom;
    }
    try {
      LoadingStart(message);
      const response = await axios.post(link, data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN) || null,
          ...(custom ? { "x-app-auth": custom } : {}),
        },
      });

      LoadingEnd();
      if (!response.data.success) {
        if ("tokenExpStatus" in response.data) {
          if (response.data.tokenExpStatus) {
            errorMessage(response.data.msg, null);
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem("userDetails");
            window.location.reload();
            return false;
          }
        }
      }
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      LoadingEnd();

      throw error;
    }
  },
  postPlayer: async (link, data, message) => {
    try {
      LoadingStart(message);
      const response = await axios.post(link, data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN) || null,
        },
      });

      LoadingEnd();
      if (!response.data.success) {
        if ("tokenExpStatus" in response.data) {
          if (response.data.tokenExpStatus) {
            // errorMessage(response.data.msg, null);
            // localStorage.removeItem(AUTH_TOKEN);
            // localStorage.removeItem("userDetails");
            // window.location.reload();
            return false;
          }
        }
      }
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      LoadingEnd();

      throw error;
    }
  },
  postToken: async (link, data, message) => {
    try {
      const response = await axios.post(link, data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN) || null,
        },
      });
      if (!response.data.success) {
        if ("tokenExpStatus" in response.data) {
          if (response.data.tokenExpStatus) {
            errorMessage(response.data.msg, null);
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem("userDetails");
            window.location.reload();
            return false;
          }
        }
      }
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },
  put: async (link, data, message) => {
    const custom = data?.custom ? data?.custom : null;
    if (custom) {
      delete data.custom;
    }
    try {
      LoadingStart(message);
      const response = await axios.put(link, data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN) || null,
          ...(custom ? { "x-app-auth": custom } : {}),
        },
      });

      LoadingEnd();
      if (!response.data.success) {
        if ("tokenExpStatus" in response.data) {
          if (response.data.tokenExpStatus) {
            errorMessage(response.data.msg, null);
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem("userDetails");
            window.location.reload();
            return false;
          }
        }
      }
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      LoadingEnd();

      throw error;
    }
  },
  delete: async (link, data, message) => {
    try {
      LoadingStart(message);
      const response = await axios.delete(link, {
        params: data,
        headers: {
          Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN) || null,
        },
      });

      LoadingEnd();
      if (!response.data.success) {
        if ("tokenExpStatus" in response.data) {
          if (response.data.tokenExpStatus) {
            errorMessage(response.data.msg, null);
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem("userDetails");
            window.location.reload();
            return false;
          }
        }
      }
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      LoadingEnd();

      throw error;
    }
  },
  patch: async (link, data, message) => {
    const custom = data?.custom ? data?.custom : null;
    if (custom) {
      delete data.custom;
    }
    try {
      LoadingStart(message);
      const response = await axios.patch(link, data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN) || null,
          ...(custom ? { "x-app-auth": custom } : {}),
        },
      });

      LoadingEnd();
      if (!response.data.success) {
        if ("tokenExpStatus" in response.data) {
          if (response.data.tokenExpStatus) {
            errorMessage(response.data.msg, null);
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem("userDetails");
            window.location.reload();
            return false;
          }
        }
      }
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      LoadingEnd();

      throw error;
    }
  },
  showMessageAndNavigate: async (title, content, navigationRoute, status, history) => {
    const messageFunction = status === "error" ? message.error : status === "success" ? message.success : status === "info" ? message.info : null;

    if (messageFunction) {
      messageFunction({
        content: content,
        style: {
          marginTop: "20vh",
        },
        duration: 2,
        onClose: () => {},
      });
    }
  },
  consoleProvider: async (title, msg) => {
    if (msg == null) {
      SERVER_TYPE === "Development" && console.log(title);
    } else {
      SERVER_TYPE === "Development" && console.log(title, msg);
    }
  },
};

export default apiRequest;
